export default __webpack_public_path__ + "navigation-examples-electronic-horizon-1200-ef516e3629f08b073adad896a6470800.webp";